export const TOGGLE_MINI_PLAYER = 'TOGGLE_MINI_PLAYER';
